/**
 * Styled focus indicator for character cards in lists.
 * Displays a white border around focused character cards in IA Corner displays.
 */

import styled from 'styled-components';
import Screen from '../../../../shared/utils/screen';

/**
 * Focus indicator border for character cards with absolute positioning.
 */
const CharacterCardListFocus = styled.div`
  width: ${200 * Screen.widthRatio}px;
  height: ${200 * Screen.widthRatio}px;
  border: ${4 * Screen.widthRatio}px solid white;
  border-radius: ${24 * Screen.widthRatio}px;
  left: ${-4 * Screen.widthRatio}px;
  position: absolute;
  z-index: -1;
`;

export default CharacterCardListFocus;
